import moment from 'moment';
import { KEYMAN_COPY_DAILY_LIMIT } from '../constants/Constants';

// キーマンデータベースのコピー回数をlocalStorageに保存する際のキープレフィックス
const STORAGE_KEY_PREFIX = 'keymanCopyCount';

// 当日のコピー回数を保存するlocalStorageキーを生成する（ユーザー・日付ごとに分離）
const buildStorageKey = (identifier) => {
  const today = moment().format('YYYY-MM-DD');
  const safeIdentifier = identifier || 'unknown';
  return `${STORAGE_KEY_PREFIX}:${safeIdentifier}:${today}`;
};

// 当日のコピー回数を取得する（未記録・取得不可の場合は0）
export const getTodayCopyCount = (identifier) => {
  try {
    const value = window.localStorage.getItem(buildStorageKey(identifier));
    const count = parseInt(value, 10);
    return isNaN(count) ? 0 : count;
  } catch (e) {
    // プライベートブラウジング等でlocalStorageが使えない場合は0を返す
    return 0;
  }
};

// 当日のコピー回数を1加算し、更新後の回数を返す
export const incrementTodayCopyCount = (identifier) => {
  const next = getTodayCopyCount(identifier) + 1;
  try {
    window.localStorage.setItem(buildStorageKey(identifier), next.toString());
  } catch (e) {
    // localStorageに書き込めない環境でもユーザー操作は妨げない
  }
  return next;
};

// 当日のコピー回数が上限を超えているか判定する
export const isCopyCountOverLimit = (count, limit = KEYMAN_COPY_DAILY_LIMIT) => {
  return count > limit;
};



// WEBPACK FOOTER //
// ./src/utils/copyDetectionUtils.js